/* PDF */
export const GET_PDF = "GET_PDF"
export const GET_PDF_SUCCESS = "GET_PDF_SUCCESS"
export const GET_PDF_FAIL = "GET_PDF_FAIL"